export const renderedText = (element: HTMLElement | null): string =>
  (element?.innerText || element?.textContent || "").trim();
